// PoC 実機確認用・#10 統合後に削除 — issue #60 iPhone Safari サムネイル描画 GO/NOGO ゲート。
// PDF を選ぶ → usePdfThumbnails でサムネイル遅延描画 → タップ選択 → 選択サマリ表示、を
// 実機 Safari で確認するためだけの一時ページ。#10 (FingeringForm 統合) 完了時にこのファイルと
// App.tsx の /poc-pagerange ルートを削除する。
import React, { useState } from 'react';
import PageRangeSelector from '../fingering/components/PageRangeSelector';
import { pageSetToRanges } from '../../utils/pageRangeConvert';

function rangesToLabel(ranges: number[][]): string {
  return ranges.map(([s, e]) => (s === e ? `${s}` : `${s}-${e}`)).join(',');
}

const PocPageRangePage: React.FC = () => {
  const [file, setFile] = useState<File | null>(null);
  const [selectedPages, setSelectedPages] = useState<Set<number>>(new Set());

  const handleFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const next = e.target.files?.[0] ?? null;
    setFile(next);
    setSelectedPages(new Set());
  };

  const label = rangesToLabel(pageSetToRanges(selectedPages));

  return (
    <div className="mx-auto max-w-md space-y-4 rounded-2xl bg-white p-5 shadow">
      <h1 className="text-lg font-bold text-gray-700">PoC: PDF サムネイル選択 (#60)</h1>
      <p className="text-xs text-gray-500">
        iPhone 実機確認用の一時ページです。PDF を選ぶとサムネイルが遅延描画されます。
        サムネイルをタップで選択し、下に選択レンジが表示されます。
      </p>
      <input
        type="file"
        accept="application/pdf"
        onChange={handleFile}
        aria-label="PDF ファイルを選択"
        className="block w-full text-sm text-gray-700 file:mr-3 file:rounded-lg file:border-0 file:bg-brand-purple file:px-3 file:py-2 file:text-white"
      />
      <PageRangeSelector
        pdfBlob={file}
        selectedPages={selectedPages}
        onChange={setSelectedPages}
        onInit={setSelectedPages}
      />
      <div className="rounded-lg bg-gray-50 p-3 text-sm text-gray-700">
        {file
          ? `選択: ${selectedPages.size} ページ${label ? ` / レンジ ${label}` : '（未選択＝全ページ扱い）'}`
          : 'PDF ファイルを選んでください。'}
      </div>
    </div>
  );
};

export default PocPageRangePage;
